(function ($) {
    'use strict';

    const $form        = $( '#om-filter-form' );
    const $results     = $( '#om-results' );
    const $pagination  = $( '#om-pagination' );
    const $count_text  = $( '#om-count-text' );
    const $spinner     = $( '#om-spinner' );
    const $active_wrap = $( '#om-active-filters' );
    const $tags        = $( '#om-filter-tags' );
    const $orderby     = $( '#om-orderby' );

    let current_page = 1;
    let is_loading   = false;

    $( document ).ready( function () {
        const instant = ( $( window ).scrollTop() > 200 || window.innerWidth < 768 );
        animate_cards( instant );

        const url_params = new URLSearchParams( window.location.search );
        if ( url_params.get( 'orderby' ) ) {
            $orderby.val( url_params.get( 'orderby' ) );
        }
    } );

    $form.on( 'submit', function (e) {
        e.preventDefault();
        current_page = 1;
        do_search( 1 );
    } );

    $orderby.on( 'change', function () {
        current_page = 1;
        do_search( 1 );
    } );

    $tags.on( 'click', '.om-properties__filter-tag', function () {
        const filter = $( this ).data( 'filter' );
        if ( filter === 'location' )      $( '#om-location' ).val( '' );
        if ( filter === 'property_type' ) $( '#om-type' ).val( '' );
        current_page = 1;
        do_search( 1 );
    } );

    $pagination.on( 'click', 'li', function () {
        const page = parseInt( $( this ).attr( 'data-page' ), 10 );
        if ( ! page || $( this ).find( '.current' ).length || is_loading ) return;
        current_page = page;
        do_search( current_page );
    } );

    $( window ).on( 'popstate', function (e) {
        const state = e.originalEvent.state;
        if ( ! state || ! state.filters ) return;
        const f = state.filters;
        $( '#om-location' ).val( f.location      || '' );
        $( '#om-type' ).val( f.property_type      || '' );
        $orderby.val( f.orderby                   || 'date_desc' );
        current_page = f.paged || 1;
        do_search( current_page );
    } );
    function do_search( page ) {
        if ( is_loading ) return;
        is_loading = true;

        const filters = get_filters();
        filters.paged = page;

        update_url( filters );

        const data = Object.assign( { action: 'om_filter_properties', nonce: om_ajax.nonce }, filters );

        $spinner.addClass( 'is-visible' );
        $count_text.text( 'Zoeken…' );
        $results.addClass( 'om-properties__grid--loading' );

        $.post( om_ajax.url, data )
            .done( function (res) {
                if ( ! res.success ) return;
                const d = res.data;

                $results.html( d.html );
                $results.removeClass( 'om-properties__grid--loading' );
                animate_cards( true );

                const n = parseInt( d.found_posts, 10 );
                $count_text.text( n + ' Woning' + ( n !== 1 ? 'en' : '' ) + ' gevonden' );
                $spinner.removeClass( 'is-visible' );

                update_active_tags( filters );
                build_pagination( page, parseInt( d.max_pages, 10 ) );
            } )
            .fail( function () {
                $results.html( '<div class="om-error">Er is iets misgegaan. Probeer het opnieuw.</div>' );
                $spinner.removeClass( 'is-visible' );
                $count_text.text( '' );
            } )
            .always( function () { is_loading = false; } );
    }
    function get_filters() {
        return {
            location:      $( '#om-location' ).val().trim(),
            property_type: $( '#om-type' ).val(),
            orderby:       $orderby.val(),
            per_page:      12,
        };
    }
    function update_url( filters ) {
        const params = new URLSearchParams();
        if ( filters.location )      params.set( 'location',      filters.location );
        if ( filters.property_type ) params.set( 'property_type', filters.property_type );
        if ( filters.orderby && filters.orderby !== 'date_desc' ) params.set( 'orderby', filters.orderby );
        if ( filters.paged > 1 )     params.set( 'paged',         filters.paged );

        const new_url = om_ajax.archive_url + ( params.toString() ? '?' + params.toString() : '' );
        window.history.pushState( { filters }, '', new_url );
    }
    function update_active_tags( filters ) {
        $tags.empty();
        let has_filters = false;

        if ( filters.location ) {
            append_tag( filters.location, 'location' );
            has_filters = true;
        }

        if ( filters.property_type ) {
            const label = $( '#om-type option[value="' + filters.property_type + '"]' ).text() || filters.property_type;
            append_tag( label, 'property_type' );
            has_filters = true;
        }

        $active_wrap.toggle( has_filters );
    }
    function append_tag( label, filter_key ) {
        $tags.append(
            $( '<button class="om-properties__filter-tag" type="button"></button>' )
                .attr( 'data-filter', filter_key )
                .text( label )
                .append( '<i class="om-icon om-icon-x"></i>' )
        );
    }
    function animate_cards( instant ) {
        $results.find( '.om-property-card' ).each( function (i) {
            const $card = $( this );
            if ( instant ) {
                $card.addClass( 'om-property-card--visible' );
            } else {
                setTimeout( function () { $card.addClass( 'om-property-card--visible' ); }, i * 60 );
            }
        } );
    }
    function build_pagination( current, max ) {
        $pagination.empty();
        if ( max <= 1 ) return;

        const $ul = $( '<ul class="om-page-list"></ul>' );

        if ( current > 1 ) {
            $ul.append( page_btn( '&lsaquo;', current - 1, false, 'om-page-btn--arrow' ) );
        }

        get_page_range( current, max ).forEach( function (p) {
            $ul.append( p === '…'
                ? page_btn( '&hellip;', null, false, 'om-page-ellipsis' )
                : page_btn( p, p, p === current )
            );
        } );

        if ( current < max ) {
            $ul.append( page_btn( '&rsaquo;', current + 1, false, 'om-page-btn--arrow' ) );
        }

        $pagination.append( $ul );
    }
    function page_btn( label, page, is_active, extra ) {
        const $span = $( '<span></span>' )
            .addClass( 'page-numbers' + ( extra ? ' ' + extra : '' ) + ( is_active ? ' current' : '' ) )
            .html( label );

        return $( '<li></li>' )
            .attr( 'data-page', page )
            .append( $span );
    }
    function get_page_range( current, max ) {
        if ( max <= 7 ) return range( 1, max );
        if ( current <= 4 ) return [ ...range( 1, 5 ), '…', max ];
        if ( current >= max - 3 ) return [ 1, '…', ...range( max - 4, max ) ];
        return [ 1, '…', current - 1, current, current + 1, '…', max ];
    }

    function range( a, b ) {
        const r = [];
        for ( let i = a; i <= b; i++ ) r.push( i );
        return r;
    }

})( jQuery );